
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { useInquiryForm } from "@/hooks/useInquiryForm";

import { CTASection } from "@/sections/CTASection";
import { ColorfulCTASection } from "@/sections/ColorfulCTASection";
import { DashboardScreenSection } from "@/sections/DashboardScreenSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { TestimonialsSection } from "@/sections/TestimonialsSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ToolsVisualizationSection } from "@/sections/ToolsVisualizationSection";

import { TrustedBySection } from "@/sections/TrustedBySection";
import { ConvertAllFormatsSection } from "@/sections/ConvertAllFormatsSection";
import { TerminalImagesSection } from "@/sections/TerminalImagesSection";
import { useTheme } from "@/hooks/useTheme";
import { FormSourceType } from "@/containers/InquiryForm";

const Enterprise = () => {
  const { t } = useTranslation();
  const { toggleInquiryForm } = useInquiryForm();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/enterprise"
        ogImage="/images/design-file-api-og-image.jpg"
      />

      <DashboardScreenSection
        title={t("page/enterprise:title")}
        subtitle={t("page/enterprise:subtitle")}
        src="/images/dashboard-image.jpg"
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SWITCH-ICON",
            text: t("page/enterprise:headerListItems.teaser1"),
          },
          {
            id: "ELEMENT#2",
            iconType: "DESIGN-TOOL-ICON",
            text: t("page/enterprise:headerListItems.teaser2"),
          },
          {
            id: "ELEMENT#3",
            iconType: "SYNC-RED-ICON",
            text: t("page/enterprise:headerListItems.teaser3"),
          },
          {
            id: "ELEMENT#4",
            iconType: "LOCK-DOT-ICON",
            text: t("page/enterprise:headerListItems.teaser4"),
          },
          {
            id: "ELEMENT#5",
            iconType: "INTEGRATION-ICON",
            text: t("page/enterprise:headerListItems.teaser5"),
          },
        ]}
        onButtonClick={() =>
          toggleInquiryForm(FormSourceType.ENTERPRISE_LANDING_PAGE_INQUIRY)
        }
        buttonLabel={t("page/enterprise:headerButtonLabel")}
      />

      <TrustedBySection />

      <ToolsVisualizationSection
        title={t("page/enterprise:section/toolsVisualization.title")}
        imageAlt={t("page/enterprise:section/toolsVisualization.imageAlt")}
      />

      <ConvertAllFormatsSection
        elements={[
          {
            id: "convertFormats#1",
            title: t("section/convertAllFormats:elements.firstElement.title"),
            subtitle: t(
              "section/convertAllFormats:elements.firstElement.subtitle",
            ),
            image: {
              src: "/images/illustration-upload.jpg",
              alt: t(
                "section/convertAllFormats:elements.firstElement.imageAlt",
              ),
            },
          },
          {
            id: "convertFormats#2",
            title: t("section/convertAllFormats:elements.secondElement.title"),
            subtitle: t(
              "section/convertAllFormats:elements.secondElement.subtitle",
            ),
            image: {
              src: "/images/illustration-upload-done.jpg",
              alt: t(
                "section/convertAllFormats:elements.secondElement.imageAlt",
              ),
            },
          },
        ]}
      />

      <ColorfulCTASection
        title={t("section/colorfulCta:titles.enterprisePage")}
        onButtonClick={() =>
          toggleInquiryForm(FormSourceType.ENTERPRISE_LANDING_PAGE_INQUIRY)
        }
        buttonLabel={t("section/colorfulCta:buttonDefaultLabel")}
      />

      <ApiTeaserSection
        title={t("page/enterprise:section/apiTeaser.title")}
        image={{
          src: "/svgs/magician-cloud.svg",
          alt: "Magician with cloud",
        }}
        elements={t(
          "page/enterprise:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={t("page/enterprise:section/shareDesign.title")}
        image={{
          src: "/images/share-design-image.jpg",
          alt: t("page/enterprise:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            text: t("page/enterprise:section/shareDesign.elements.shareDesign"),
          },
          {
            id: "ELEMENT#2",
            iconType: "SHARE-ICON",
            text: t(
              "page/enterprise:section/shareDesign.elements.shareDesignWithClients",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "COMPANY-ICON",
            text: t(
              "page/enterprise:section/shareDesign.elements.connectTeams",
            ),
          },
          {
            id: "ELEMENT#4",
            iconType: "TOGETHER-ICON",
            text: t(
              "page/enterprise:section/shareDesign.elements.workTogether",
            ),
          },
        ]}
      />
      <TerminalImagesSection />
      <TestimonialsSection />
      <CTASection
        title="Start optimizing your design workflows today"
        buttonLabel="Contact Sales"
        onButtonClick={() =>
          toggleInquiryForm(FormSourceType.ENTERPRISE_LANDING_PAGE_INQUIRY)
        }
      />
    </>
  );
};

export default Enterprise;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/enterprise',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  